import { Skeleton } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Notification from './Notification';
import './Notification.css';

function NotificationList({ notis, handleUpdateSentNoti, setOpenNotificationBox, setCurrentPage }) {
    const { t } = useTranslation();

    const trackLoadCourses = () => {
        const el = document.getElementsByClassName("notificationList")[0];
        try {
            if (Math.ceil(el.scrollTop) + el.offsetHeight === el.scrollHeight) {
                setCurrentPage(prevCurrentPage => prevCurrentPage + 1)
            }
        } catch (e) {
            el.removeEventListener("scroll", trackLoadCourses);
        }
    };

    useEffect(() => {
        document?.getElementsByClassName('notificationList')[0]?.addEventListener('scroll', trackLoadCourses)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="notificationList">
            {notis?.map((noti, ind) => {
                if (noti?.isLoading) {
                    return (
                        <div
                            style={{
                                borderBotton: '1px solid #dedede',
                                margin: '8px'
                            }}
                        >
                            <div className='header' style={{ width: '50%' }}>
                                <Skeleton />
                            </div>
                            <div className='body'>
                                <Skeleton />
                                <Skeleton />
                            </div>
                        </div>
                    )
                } else if (noti?.lastNotification) {
                    return (
                        <div
                            style={{
                                padding: '16px',
                                textAlign: 'center'
                            }}
                        >
                            {t('breadcrumb.no-notifications')}
                        </div>
                    )
                } else {
                    return (
                        <Notification key={ind} noti={noti} handleUpdateSentNoti={handleUpdateSentNoti} setOpenNotificationBox={setOpenNotificationBox} />
                    )
                }
            })}
        </div>
    );
}

export default NotificationList;
